export default __webpack_public_path__ + "static/custom-invoice-messages-2cca0dca7cc3a5f35210e4487697f437.jpg";